import { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  TextField,
  Typography,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import {
  phoneMask,
  TextMaskCustom,
} from "../../../profile/utils/masks";

export const SendMessageModal = ({ isOpen, onClose, template, isLoading, handleSendMessage }) => {
  const NUMBER_MAX_PHONENUMBER = 11;
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const handleReset = () => {
      setPhone("");
      setError("");
    }

    if (!isOpen) {
      handleReset();
    }

    return () => {
      handleReset();
    }
  }, [isOpen]);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
    if (error) setError("");
  };

  const handleSend = () => {
    if (!phone || phone.length !== NUMBER_MAX_PHONENUMBER) {
      setError("Informe um número válido com DDD. Ex: 11999999999");
      return;
    }

    handleSendMessage(phone);
  };

  const handleClose = () => {
    setPhone("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        Enviar mensagem de teste
        <IconButton
          aria-label="Fechar"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, py: 1 }}>
          <Alert severity="info" icon={<PhoneIphoneIcon />}>
            Informe o número de telefone que deseja usar para testar o template{" "}
            <strong>{template?.title}</strong>. O número configurado no canal
            irá disparar uma mensagem de teste diretamente para o telefone
            informado.
          </Alert>

          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Número para teste
            </Typography>
            <TextField
              fullWidth
              placeholder="Ex: (11)99999-9999"
              value={phone}
              onChange={handlePhoneChange}
              error={!!error}
              helperText={error || "Informe o DDD + número. Ex: 11999999999"}
              inputProps={{ maxLength: 11 }}
              InputProps={{
                startAdornment: (
                  <PhoneIphoneIcon sx={{ mr: 1, color: "text.secondary" }} />
                ),
                inputComponent: TextMaskCustom,
                inputProps: { mask: phoneMask },
              }}
              disabled={isLoading}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button onClick={handleClose} variant="outlined" color="inherit" disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          onClick={handleSend}
          variant="contained"
          color="primary"
          startIcon={<SendIcon />}
          endIcon={isLoading && <CircularProgress size={20} color="inherit" />}
          disabled={!phone || phone.length !== NUMBER_MAX_PHONENUMBER || isLoading }
        >
          Enviar mensagem
        </Button>
      </DialogActions>
    </Dialog>
  );
};
